import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { setUiEventViewer, trackPageView, trackDetailView, trackScreenEnter } from '@/common/analytics';
import { useViewerKey } from '@/common/featureStatus';

/**
 * 라우트 변경마다 page_view를 전송하고, 상세 페이지면 콘텐츠 조회 이벤트도 함께 전송한다.
 * (리스트 카드에 개별로 붙이지 않고 한 곳에서 처리 — 검색·외부 딥링크 유입까지 잡힌다.)
 * 화면 행동 기록(노출·클릭) 수집 스위치도 여기서 보는 사람 기준으로 맞춘다(로그인·로그아웃·라우트 이동 때 다시 확인).
 * Router 컨텍스트 안에 렌더해야 하며, 렌더 출력은 없다(부수효과 전용).
 */
const PageViewTracker = () => {
    const location = useLocation();
    const viewerKey: string = useViewerKey();
    // 인기 페이지 랭킹이 쿼리스트링으로 파편화되지 않도록 pathname만 집계에 쓴다.
    // 상세 조회(*_VIEW)는 pathname에만 의존 — 쿼리만 바뀔 때(?tab= 등) 중복 카운트 방지.
    const alimtalkId = new URLSearchParams(location.search).get('alimtalkId') || undefined;
    useEffect(() => {
        trackPageView(location.pathname, alimtalkId);
    }, [location.pathname, alimtalkId]);
    useEffect(() => {
        trackDetailView(location.pathname);
        // 화면 머문 시간 — 앞 화면을 마감하고 이 화면을 잰다(화면 행동 기록 스위치가 꺼져 있으면 보내지 않는다)
        trackScreenEnter(location.pathname);
    }, [location.pathname]);
    // 보는 사람이 바뀌거나(로그인 등) 화면을 옮길 때 — 스위치는 5분 안이면 다시 묻지 않는다
    useEffect(() => {
        setUiEventViewer(viewerKey);
    }, [viewerKey, location.pathname]);
    return null;
};

export default PageViewTracker;
